import { PasswordChanged } from "../../../../images/xd/icons"
import { styled, theme } from "../../../../styles/stitches.config"

export const SImage = styled(PasswordChanged, {
  width: theme.space.s52,
})
